<template>
    <div>
      <!-- 遍历菜单列表 -->
      <template v-for="item in menuList" >
        <!-- 如果有子菜单，渲染 el-submenu -->
        <el-submenu style="background-color: #2a0608;"
          v-if="item.children && item.children.length > 0"
          :index="item.path"
          :key="item.id" 
        >
          <template #title>
            <i :class="item.clazz"></i>
            <span>{{ item.label }}</span>
          </template>
          <!-- 递归调用自身，渲染子菜单 -->
          <menu-item :menu-list="item.children" @select-menu="selectMenu" />
        </el-submenu>
        <!-- 如果没有子菜单，渲染 el-menu-item -->
        <el-menu-item
          v-else
          :index="item.path"
          :key="item.id" 
          @click="selectMenu(item)"
        >
          <i :class="item.clazz"></i>
          <span>{{ item.label }}</span>
        </el-menu-item>
      </template>
    </div>
  </template>
  
  <script>
  export default {
    name: 'MenuItem',
    props: {
      menuList: {
        type: Array,
        required: true,
      },
    },
    methods: {
      // 选中菜单的回调
      selectMenu(item) {
        this.$emit('select-menu', item);
      },
    },
  };
  </script>
  <style lang="less" scoped>
// 菜单选中背景色
.el-menu-item.is-active {
  background-color: #f5212d !important;
}

// 菜单悬浮背景色
.el-menu-item:hover {
  background-color: #f5212d !important;
}
</style>